import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";
import { getShows } from "../../Redux/Actions/actions"; // Importar la acción para traer los shows
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";


const SoldTickets = () => {
  const dispatch = useDispatch();

  // Estados de los tickets y los shows
  const [tickets, setTickets] = useState([]);
  const [noCancelledTickets, setNoCancelledTickets] = useState([]);
  const [cancelledTickets, setCancelledTickets] = useState([]);
  const [divisionFilter, setDivisionFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [cashierFilter, setCashierFilter] = useState("");
  const [canceledFilter, setCanceledFilter] = useState(null); // Filtro para tickets cancelados
  const [showFilter, setShowFilter] = useState(""); // Filtro para el nombre del show
  const [users, setUsers] = useState([]); // Para almacenar todos los usuarios que son cajeros
  const [giftedFilter, setGiftedFilter] = useState(null); // Filtro para tickets regalados
  const [userFilter, setUserFilter] = useState("");
  const [search, setSearch] = useState("");
  const user = useSelector((state) => state?.user);
  const [ticketIdFilter, setTicketIdFilter] = useState("");
  const [visibleTickets, setVisibleTickets] = useState([]);
  const [showCleanModal, setShowCleanModal] = useState(false);
  const [selectedZone, setSelectedZone] = useState(null);
  const navigate = useNavigate();

  // Traer los shows desde Redux
  const shows = useSelector((state) => state.shows);

  useEffect(() => {
    // Llamada a la API para obtener los tickets vendidos
    fetchTickets();
    dispatch(getShows()); // Traer los shows desde la acción
    fetchUsers(); // Llamada a la API para obtener los usuarios
  }, [dispatch]);

  useEffect(() => {
    filterTickets();
  }, [divisionFilter, canceledFilter, showFilter, tickets, dateFilter, cashierFilter, userFilter, ticketIdFilter]); // Incluir cashierFilter en las dependencias


  ///ASIGNACION DE TIKETS POR EVENTOS HABILITADOS///
  useEffect(() => {
    if (!tickets || !user) return;

    if (user.isAdmin) {
      setVisibleTickets(tickets);
      return;
    }

    // 👇 CAJERO O USUARIO SOLO VE SUS TICKETS
    const onlyMyTickets = tickets.filter(
      (ticket) => ticket.userId === user.id
    );

    setVisibleTickets(onlyMyTickets);
  }, [tickets, user]);

  // Llamada a la API para obtener los tickets vendidos
  const fetchTickets = async () => {
    try {
      const response = await axios.get("/tickets");
      setTickets(response.data.tickets);

    } catch (error) {
      console.error("Error al cargar los tickets:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron cargar los tickets vendidos.",
      });
    }
  };

  // Llamada a la API para obtener los usuarios (cajeros)
  // Llamada a la API para obtener los usuarios
  const fetchUsers = async () => {
    try {
      const response = await axios.get("/users");
      const allUsers = response.data || []; // Obtener todos los usuarios

      // Filtrar solo los cajeros (los que tienen 'cashier' en true)
      const cashierUsers = allUsers.filter(user => user.cashier);
      // Filtrar solo los usuarios comunes (los que no son 'cashier' ni 'isAdmin')
      const commonUsers = allUsers.filter(user => !user.cashier && !user.isAdmin);

      // Combinar los usuarios comunes y cajeros
      setUsers([...cashierUsers, ...commonUsers]);
    } catch (error) {
      console.error("Error al cargar los usuarios:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron cargar los usuarios.",
      });
    }
  };

  const filterTickets = () => {
    if (!tickets || !users) return;

    // Inicializamos los tickets visibles según el rol del usuario
    let filtered = user.isAdmin ? tickets : visibleTickets;

    // ======== FILTROS ========

    // Tickets regalados
    if (giftedFilter !== null) {
      filtered = filtered.filter(ticket =>
        (giftedFilter === "true" && ticket.price === 0) ||
        (giftedFilter === "false" && ticket.price !== 0)
      );
    }

    // División
    if (divisionFilter) {
      filtered = filtered.filter(ticket => ticket.division === divisionFilter);
    }

    // Estado cancelado
    if (canceledFilter !== null) {
      const isActive = canceledFilter === "true";
      filtered = filtered.filter(ticket => ticket.state === isActive);
    }

    // ID de ticket
    if (ticketIdFilter && ticketIdFilter.trim() !== "") {
      filtered = filtered.filter(ticket => String(ticket.id) === String(ticketIdFilter));
    }

    // Fecha
    if (dateFilter) {
      filtered = filtered.filter(ticket => ticket.date === dateFilter);
    }

    // Cajero
    if (cashierFilter) {
      filtered = filtered.filter(ticket => ticket.userId === cashierFilter);
    }

    // Filtro por usuario (nombre o email)
    if (userFilter && userFilter.trim() !== "") {
      const filterLower = userFilter.toLowerCase();
      filtered = filtered.filter(ticket => {
        const usuario = users.find(u => u.id === ticket.userId);
        if (!usuario) return false;
        return (
          usuario.name.toLowerCase().includes(filterLower) ||
          usuario.email.toLowerCase().includes(filterLower)
        );
      });
    }

    // Filtro por show
    if (showFilter && shows) {
      filtered = filtered.filter(ticket => {
        const show = shows.find(s => s.id === ticket.showId);
        return show && show.name.toLowerCase().includes(showFilter.toLowerCase());
      });
    }

    // ======== SEPARAR TICKETS ACTIVOS Y CANCELADOS ========
    // No importa si tienen fila/asiento o son tribunas generales
    const noCancelled = filtered.filter(ticket => ticket.state === true);
    const cancelled = filtered.filter(ticket => ticket.state === false);

    // Actualizamos los estados
    setNoCancelledTickets(noCancelled);
    setCancelledTickets(cancelled);
  };



  // Obtener las divisiones disponibles
  const divisions = [...new Set(tickets.map(ticket => ticket.division))];
  const date = [...new Set(tickets.map(ticket => ticket.date))];


  const zonesAvailable = Object.values(
    tickets.reduce((acc, ticket) => {

      const key = `${ticket.showId}-${ticket.zoneId}`;

      if (!acc[key]) {
        const show = shows.find(
          s => s.id === ticket.showId
        );

        acc[key] = {
          zoneId: ticket.zoneId,
          showId: ticket.showId,
          showName: show?.name || "Cargando...",
          divisions: []
        };
      }

      if (!acc[key].divisions.includes(ticket.division)) {
        acc[key].divisions.push(ticket.division);
      }

      return acc;

    }, {})
  );

  // Lógica de cancelación de tickets
  const cancelTicket = async (ticket) => {


    const result = await Swal.fire({
      title: '¿Estás seguro de cancelar este ticket?',
      text: `El ticket con ID ${ticket.id} será cancelado y el asiento será liberado.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cancelar ticket',
      cancelButtonText: 'No, volver',
    });

    if (result.isConfirmed) {
      try {
        // Buscar el show asociado al ticket
        const show = shows.find(s => s.id === ticket.showId);


        if (!show) {
          throw new Error(`El show con ID ${ticket.showId} no existe.`);
        }

        // Elegir endpoint según la propiedad isGeneral
        if (show.isGeneral) {

          await axios.delete(`/tickets/cancel/${ticket.id}`);
        } else {

          await axios.delete(`/tickets/cancel/${ticket.id}`);
        }

        Swal.fire({
          icon: "success",
          title: "Ticket Cancelado",
          text: `El ticket con ID ${ticket.id} ha sido cancelado exitosamente.`,
        });

        fetchTickets(); // Refrescar tickets después de cancelar
      } catch (error) {
        console.error("Error al cancelar el ticket:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo cancelar el ticket. Por favor, inténtalo de nuevo.",
        });
      }
    }
  };


  // Paginación
  const [currentPage, setCurrentPage] = useState(1);
  const ticketsPerPage = 5;

  // Aplicamos todos los filtros sobre los tickets

  const ticketsFiltered = noCancelledTickets.filter(ticket => {
    // Filtro por Tickets Regalados (price === 0)
    if (giftedFilter !== null) {
      if (giftedFilter === "true" && ticket.price !== 0) return false;
      if (giftedFilter === "false" && ticket.price === 0) return false;
    }

    // Filtro por división
    if (divisionFilter && ticket.division !== divisionFilter) return false;

    // Filtro por cancelación
    if (canceledFilter !== null && ticket.state !== canceledFilter) return false;

    // Filtro por fecha
    if (dateFilter && ticket.date !== dateFilter) return false;

    // Filtrar por Cajero
    if (cashierFilter && ticket.userId !== cashierFilter) return false;

    // Filtrar por usuario
    if (userFilter && userFilter.trim() !== "") {
      const filterLower = userFilter.toLowerCase();
      const usuario = users.find(u => u.id === ticket.userId);
      if (!usuario) return false;
      if (
        !usuario.name.toLowerCase().includes(filterLower) &&
        !usuario.email.toLowerCase().includes(filterLower)
      ) return false;
    }

    // Filtro por nombre del show
    if (showFilter && shows) {
      const show = shows.find(show => show.id === ticket.showId);
      if (!show || !show.name.toLowerCase().includes(showFilter.toLowerCase())) return false;
    }

    return true;
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [userFilter, showFilter, divisionFilter, dateFilter, cashierFilter, giftedFilter, canceledFilter]);


  // Paginación sobre los tickets filtrados
  const totalPages = Math.ceil(ticketsFiltered.length / ticketsPerPage);
  const currentTickets = ticketsFiltered.slice((currentPage - 1) * ticketsPerPage, currentPage * ticketsPerPage);

  // Lógica para definir el rango de páginas visibles
  const maxVisiblePages = 3;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage + 1 < maxVisiblePages) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  // Cambiar de página
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleDownloadExcel = () => {
    let filteredData = [...ticketsFiltered];

    // Filtrado por tickets regalados
    if (giftedFilter !== null) {
      filteredData = filteredData.filter(ticket =>
        (giftedFilter === "true" && ticket.price === 0) ||
        (giftedFilter === "false" && ticket.price !== 0)
      );
    }

    if (divisionFilter) filteredData = filteredData.filter(ticket => ticket.division === divisionFilter);
    if (canceledFilter !== null) filteredData = filteredData.filter(ticket => ticket.state === (canceledFilter === "true"));
    if (dateFilter) filteredData = filteredData.filter(ticket => ticket.date === dateFilter);
    if (cashierFilter) filteredData = filteredData.filter(ticket => ticket.userId === cashierFilter);
    if (userFilter && userFilter.trim() !== "") {
      const filterLower = userFilter.toLowerCase();
      filteredData = filteredData.filter(ticket => {
        const ticketUser = users.find(u => u.id === ticket.userId) || (user.id === ticket.userId ? user : null);
        if (!ticketUser) return false;
        return ticketUser.name.toLowerCase().includes(filterLower) || ticketUser.email.toLowerCase().includes(filterLower);
      });
    }

    if (showFilter && shows) {
      filteredData = filteredData.filter(ticket => {
        const show = shows.find(s => s.id === ticket.showId);
        return show && show.name.toLowerCase().includes(showFilter.toLowerCase());
      });
    }

    // Solo tickets activos
    filteredData = filteredData.filter(ticket => ticket.state === true);

    // Preparar datos para Excel con PORSENTAJE DE AUMENTO REVISAR ESTO.
    const prepareDataForExport = (data) => {
      return data.map(ticket => {

        // Ahora usamos directamente el precio final con recargo
        const priceWithTax =
          Number(ticket.price) === 0
            ? 0
            : Number(ticket.chargePrice ?? ticket.price ?? 0);
        const ticketUser = users.find(u => u.id === ticket.userId) || (user.id === ticket.userId ? user : null);
        const userName = ticketUser ? ticketUser.name : "Usuario desconocido";
        const userEmail = ticketUser ? ticketUser.email : "Sin correo";
        const userPhone = ticketUser ? ticketUser.phone || "Sin Celular" : "Sin Celular";
        const userType = ticketUser && ticketUser.cashier ? `Cajero: ${userName}` : `Nombre: ${userName}`;
        const buyerEmail = ticket.mail || "Sin correo";

        return {
          Show: shows.find(s => s.id === ticket.showId)?.name || "Cargando...",
          Division: ticket.division || "Desconocida",
          Fila: ticket.row || "Libre",
          Asiento: ticket.seat || "Libre",
          Price: priceWithTax.toFixed(2),
          Usuario: userType,
          Email: userEmail,
          Telefono: userPhone,
          "Venta a": buyerEmail,
          Fecha: ticket.date.split(" || ")[0] || "Fecha no disponible",
          Hora: ticket.date.split(" || ")[1] || "Hora no disponible",
        };
      });
    };

    // Separar tickets de cajeros y usuarios
    const dataForCashiers = prepareDataForExport(filteredData.filter(ticket => {
      const ticketUser = users.find(u => u.id === ticket.userId) || (user.id === ticket.userId ? user : null);
      return ticketUser && ticketUser.cashier;
    }));

    const dataForUsers = prepareDataForExport(filteredData.filter(ticket => {
      const ticketUser = users.find(u => u.id === ticket.userId) || (user.id === ticket.userId ? user : null);
      return !ticketUser?.cashier;
    }));

    // Totales
    const totalPriceCashiers = dataForCashiers.reduce((acc, t) => acc + parseFloat(t.Price), 0);
    const totalPriceUsers = dataForUsers.reduce((acc, t) => acc + parseFloat(t.Price), 0);
    const totalPriceTickets = filteredData.reduce(
      (acc, ticket) => {
        const price =
          Number(ticket.price) === 0
            ? 0
            : Number(ticket.chargePrice ?? ticket.price ?? 0);

        return acc + price;
      },
      0
    );
    dataForCashiers.push({ Show: "Total", Division: "", Fila: "", Asiento: "", Price: totalPriceCashiers.toFixed(2), Usuario: "", Fecha: "", Hora: "" });
    dataForUsers.push({ Show: "Total", Division: "", Fila: "", Asiento: "", Price: totalPriceUsers.toFixed(2), Usuario: "", Fecha: "", Hora: "" });

    // Crear workbook y agregar hojas
    const workbook = XLSX.utils.book_new();
    if (dataForCashiers.length > 0) {
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(dataForCashiers), "Cajeros");
    }
    if (dataForUsers.length > 0) {
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(dataForUsers), "Usuarios");
    }

    // Datos de cada entrada y del comprador
    const dataForTickets = filteredData.map(ticket => {
      const show = shows.find(s => s.id === ticket.showId);

      return {
        "Ticket ID": ticket.id,
        "Show": show?.name || "Cargando...",
        "División": ticket.division || "Desconocida",
        "Fila": ticket.row || "Libre",
        "Asiento": ticket.seat || "Libre",
        "Precio": (
          Number(ticket.price) === 0
            ? 0
            : Number(ticket.chargePrice ?? ticket.price ?? 0)
        ).toFixed(2),
        "Nombre comprador": ticket.name || "Sin nombre",
        "DNI comprador": ticket.dni || "Sin DNI",
        "Email comprador": ticket.mail || "Sin correo",
        "Teléfono comprador": ticket.phone || "Sin teléfono",
        "Fecha": ticket.date?.split(" || ")[0] || "Fecha no disponible",
        "Hora": ticket.date?.split(" || ")[1] || "Hora no disponible",
      };
    });

    dataForTickets.push({
      "Ticket ID": "Total",
      Show: "",
      División: "",
      Fila: "",
      Asiento: "",
      Precio: totalPriceTickets.toFixed(2),
      "Precio con recargo": "",
      "Nombre comprador": "",
      "DNI comprador": "",
      "Email comprador": "",
      "Teléfono comprador": "",
      Fecha: "",
      Hora: "",
    });

    if (dataForTickets.length > 0) {
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.json_to_sheet(dataForTickets),
        "Entradas"
      );
    }

    // Descargar Excel
    XLSX.writeFile(workbook, "tickets_no_cancelados.xlsx");
  };

  ///Formatear hora ////

  const formatCreatedAt = (createdAt) => {
    if (!createdAt) return { date: "", time: "" };

    const d = new Date(createdAt);

    return {
      date: d.toLocaleDateString("es-AR"),
      time: d.toLocaleTimeString("es-AR", {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
  };

  // Nueva función para regalar el ticket
  const giftTicket = async (ticket) => {
    const result = await Swal.fire({
      title: '¿Estás seguro de regalar este ticket?',
      text: `El ticket con ID ${ticket.id} será marcado como "regalado".`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, regalar ticket',
      cancelButtonText: 'No, volver',
    });

    if (result.isConfirmed) {
      // No es necesario usar params aquí, solo poner el ID directamente en la URL


      try {
        // Ahora pasamos el ticket ID directamente en la URL
        const response = await axios.get(`/tickets/gift/${ticket.id}`);

        Swal.fire({
          icon: "success",
          title: "Ticket Regalado",
          text: `El ticket con ID ${ticket.id} ha sido regalado exitosamente.`,
        });
        fetchTickets(); // Volver a cargar los tickets
      } catch (error) {
        console.error("Error al regalar el ticket:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo regalar el ticket. Por favor, inténtalo de nuevo.",
        });
      }

    }
  };

  const resetFilters = () => {
    setDivisionFilter("");
    setDateFilter("");
    setCashierFilter("");
    setCanceledFilter(null);
    setShowFilter("");
    setGiftedFilter(null);
    setUserFilter("");
    setTicketIdFilter("");
  };


  const handleUserFilterChange = (e) => {
    const selectedUser = e.target.value;
    setUserFilter(selectedUser ? selectedUser : ""); // No necesitas parsear a número si estás pasando string
    setCurrentPage(1); // <--- resetea la paginación al filtrar
  };

  const cleanZone = async () => {

    if (!selectedZone) return;

    const result = await Swal.fire({
      title: "¿Limpiar zona?",
      text: `Se limpiará la zona asociada al show ${selectedZone.showName}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, limpiar zona",
      cancelButtonText: "Cancelar"
    });


    if (result.isConfirmed) {

      try {

        await axios.put("/zones/flush", {
          zoneId: selectedZone.zoneId
        });


        Swal.fire({
          icon: "success",
          title: "Zona limpiada",
          text: "Los asientos fueron liberados."
        });


        setShowCleanModal(false);
        setSelectedZone(null);
        fetchTickets();


      } catch (error) {

        console.error(error);

        Swal.fire({
          icon: "success",
          title: "Resultado",
          text: response.data.message
        });

      }

    }

  };


  return (
    <div
      className="
    min-h-screen p-4 md:p-6
    w-full max-w-screen-xl
    mx-auto
    relative
    top-[220px]
    z-10
    container-bg
  "
      style={{
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <h2 className="text-white text-2xl font-bold mb-6">Detalles de Tickets</h2>
      <h3 className="text-white mb-4">
        Nombre del Cajero: {user && user.name ? user.name : "Cargando..."}
      </h3>

      {/* Filtros */}
      <div className="flex flex-wrap gap-6 mb-6">
        <div className="flex flex-col">
          <label className="text-white mb-1">Filtrar por Show:</label>
          <input
            type="text"
            value={showFilter}
            onChange={(e) => setShowFilter(e.target.value)}
            placeholder="Buscar Show"
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-white mb-1">Filtrar por División:</label>
          <select
            value={divisionFilter}
            onChange={(e) => setDivisionFilter(e.target.value)}
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="">Todas las divisiones</option>
            {divisions.map((division, index) => (
              <option key={index} value={division}>
                {division}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-white mb-1">Filtrar por Fecha:</label>
          <select
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="">Todas las fechas y Horarios</option>
            {date.map((date, index) => (
              <option key={index} value={date}>
                {date}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col">

          <label className="text-white mb-1">Buscar Usuario:</label>
          <input
            type="text"
            value={userFilter}
            onChange={(e) => setUserFilter(e.target.value)}
            placeholder="Buscar por nombre o mail"
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-white mb-1">Filtrar por Cajero:</label>
          <select
            value={cashierFilter}
            onChange={(e) => setCashierFilter(e.target.value ? Number(e.target.value) : "")}
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="">Todos los cajeros</option>
            {users.length > 0 ? (
              users
                .filter((user) => user.cashier)
                .map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.name}
                  </option>
                ))
            ) : (
              <option value="">No hay cajeros disponibles</option>
            )}
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-white mb-1">Filtrar/Estado:</label>
          <select
            value={canceledFilter}
            onChange={(e) => setCanceledFilter(e.target.value === "null" ? null : e.target.value)}
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="true">Activos</option>
            <option value="false">Cancelados</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-white mb-1">Filtrar por Regalado:</label>
          <select
            value={giftedFilter}
            onChange={(e) => setGiftedFilter(e.target.value === "null" ? null : e.target.value)}
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            <option value="null">Ninguno</option>
            <option value="true">Regalados</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-white mb-1">Buscar Ticket por Identificador:</label>
          <input
            type="number"
            value={ticketIdFilter}
            onChange={(e) => setTicketIdFilter(e.target.value)}
            placeholder="ID del ticket"
            className="p-2 rounded bg-[#608CC4] text-white border border-white focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div className="flex items-end gap-2">

          <button
            onClick={resetFilters}
            className="secondary text-white px-4 py-2 rounded"
            style={{ minHeight: '38px' }}
          >
            Resetear Filtros
          </button>

          {user.isAdmin && user.email === "solticket.show@gmail.com" && (
          <button
            onClick={() => setShowCleanModal(true)}
            className="secondary text-white px-4 py-2 rounded"
            style={{ minHeight: '38px' }}
          >
            Limpiar zona
          </button>
           )}
        </div>
      </div>

      {/* Tickets totales */}
      <h3 className="text-white font-semibold mb-2">Tickets totales:</h3>
      <div className="overflow-x-auto">
        <table className="min-w-full text-white border border-white rounded-lg">
          <thead className="bg-[#608CC4]">
            <tr>
              {["Show", "División", "Fila", "Asiento", "Cajero", "Fecha", "Hora", "Acciones"].map((head) => (
                <th key={head} className="p-3 border border-white text-white whitespace-nowrap">
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentTickets.map((ticket) => {
              const show = shows.find((show) => show.id === ticket.showId);
              const { date, time } = formatCreatedAt(ticket.createdAt);
              const isTribunaGeneral = !ticket.row && !ticket.seat;
              return (
                <tr key={ticket.id} className="hover:bg-[#ADC8E6] transition-colors">
                  <td className="p-2 border border-white">{show ? show.name : "Cargando..."}</td>
                  <td className="p-2 border border-white">{ticket.division}</td>
                  <td className="p-2 border border-white">{isTribunaGeneral ? "Libre" : ticket.row}</td>
                  <td className="p-2 border border-white">{isTribunaGeneral ? "Libre" : ticket.seat}</td>
                  <td className="p-2 border border-white">
                    {ticket.userId
                      ? users.find((u) => u.id === ticket.userId)
                        ? `${users.find((u) => u.id === ticket.userId)?.name} ${users.find((u) => u.id === ticket.userId)?.cashier === false ? "(Usuario)" : ""
                        }`
                        : "Cajero Desconocido"
                      : "Cajero Desconocido"}
                  </td>
                  <td className="p-2 border border-white">{date}</td>
                  <td className="p-2 border border-white">{time}</td>
                  <td className="p-2 border border-white">
                    {user.isAdmin && user.email === "solticket.show@gmail.com" && (
                      <div className="flex flex-col gap-2">
                        <button
                          onClick={() => cancelTicket(ticket)}
                          className="secondary text-white px-3 py-1 rounded"
                        >
                          Cancelar Ticket
                        </button>

                        <button
                          onClick={() => giftTicket(ticket)}
                          className="secondary text-white px-3 py-1 rounded"
                        >
                          Regalar Ticket
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Descargar Excel */}
      {(user?.isAdmin || user?.cashier) && (
        <button
          onClick={handleDownloadExcel}
          className="secondary text-white px-5 py-2 rounded"
        >
          📥 Descargar Excel
        </button>
      )}

      {(user?.isAdmin || user?.cashier) && (
        <button
          onClick={() =>
            navigate("/resumen-ventas", {
              state: {
                ticketsData: ticketsFiltered,
                usersData: users,
                showsData: shows,
                user,
              },
            })
          }
          className="secondary text-white px-5 py-2 rounded"
        >
          Ver resumen de ventas
        </button>
      )}

      {/* Paginación */}
      <div className="flex justify-center gap-2 mt-6 flex-wrap">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-4 py-2 rounded-full ${currentPage === 1 ? "bg-gray-400 cursor-not-allowed" : "secondary"
            }`}
        >
          ◀ Anterior
        </button>
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
          const page = startPage + i;
          return (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={`px-4 py-2 rounded-full font-bold ${page === currentPage
                ? "pagina"
                : "secondary"
                }`}
            >
              {page}
            </button>
          );
        })}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-4 py-2 rounded-full ${currentPage === totalPages ? "bg-gray-400 cursor-not-allowed" : "secondary"
            }`}
        >
          Siguiente ▶
        </button>
      </div>

      {/* Tickets cancelados (solo si aplican) */}
      {canceledFilter !== "true" && canceledFilter !== null && (
        <div className="mt-8">
          <h3 className="text-white font-semibold mb-2">Tickets Cancelados:</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full text-white border border-white rounded-lg">
              <thead className="bg-[rgba(70,70,140,0.8)]">
                <tr>
                  {["Show", "División", "Fila", "Asiento", "Cajero", "Fecha", "Hora", "Acciones"].map((head) => (
                    <th key={head} className="p-3 border border-white text-white whitespace-nowrap">
                      {head}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {cancelledTickets.map((ticket) => {
                  const { date, time } = formatCreatedAt(ticket.createdAt);
                  const show = shows.find((show) => show.id === ticket.showId);
                  return (
                    <tr key={ticket.id} className="hover:bg-[rgba(90,90,170,0.3)] transition-colors">
                      <td className="p-2 border border-white">{show ? show.name : "Cargando..."}</td>
                      <td className="p-2 border border-white">{ticket.division}</td>
                      <td className="p-2 border border-white">{ticket.row}</td>
                      <td className="p-2 border border-white">{ticket.seat}</td>
                      <td className="p-2 border border-white">
                        {ticket ? (
                          <>
                            {ticket.name} {ticket.cashier ? "" : "(Usuario)"}
                          </>
                        ) : (
                          "Cajero Desconocido"
                        )}
                      </td>
                      <td className="p-2 border border-white">{date}</td>
                      <td className="p-2 border border-white">{time}</td>
                      <td className="p-2 border border-white text-red-500 font-semibold">Cancelado</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {showCleanModal && (
        <div
          className="
      fixed inset-0
      bg-black/60
      flex items-center justify-center
      z-50
      p-4
    "
        >

          <div
            className="
        container-bg
        w-full
        max-w-lg
        rounded-lg
        border border-white
        p-5 md:p-6
      "
            style={{
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          >

            <h2 className="text-white text-xl md:text-2xl font-bold mb-5">
              Limpiar zona asociada al show
            </h2>


            <label className="text-white block mb-2">
              Seleccionar Show:
            </label>


            <select
              className="
          w-medium
          p-3
          rounded
          bg-[#608CC4]
          text-white
          border border-white
          focus:outline-none
          focus:ring-2
          focus:ring-blue-400
          z-[9999]
          relative
        "
              value={selectedZone?.zoneId || ""}
              onChange={(e) => {

                const zone = zonesAvailable.find(
                  z => z.zoneId === Number(e.target.value)
                );

                setSelectedZone(zone);

              }}
            >

              <option value="">
                Seleccione un Show
              </option>


              {zonesAvailable.map((zone) => (
                <option
                  key={`${zone.showId}-${zone.zoneId}`}
                  value={zone.zoneId}
                >
                  {zone.showName}

                </option>
              ))}

            </select>

            {selectedZone && (

              <div
                className="
            mt-5
            p-4
            rounded
            border border-white
            bg-black/20
            text-white
          "
              >

                <p className="mb-2">
                  <b>Show:</b> {selectedZone.showName}
                </p>

                <p className="mb-2">
                  <b>Divisiones:</b>
                </p>

                <ul className="list-disc ml-5">

                  {selectedZone.divisions.map((division) => (
                    <li key={division}>
                      {division}
                    </li>
                  ))}

                </ul>

              </div>

            )}

            <div
              className="
          flex
          flex-col
          sm:flex-row
          justify-end
          gap-3
          mt-6
        "
            >
              <button
                onClick={() => {
                  setShowCleanModal(false);
                  setSelectedZone(null);
                }}
                className="
            secondary
            text-white
            px-5
            py-2
            rounded
          "
              >
                Cancelar
              </button>


              <button
                onClick={cleanZone}
                disabled={!selectedZone}
                className="
            secondary
            text-white
            px-5
            py-2
            rounded
            disabled:opacity-50
          "
              >
                Limpiar zona
              </button>

            </div>

          </div>

        </div>
      )}
    </div>
  );

};

export default SoldTickets;
